import { generateCreateActionCreator, generateReadActionCreator, generateUpdateActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readProducts: generateReadActionCreator(routes.API_PRODUCT, ACTION_NAMES.PRODUCT),
    readCategoryProducts: generateReadActionCreator(routes.API_PRODUCT, ACTION_NAMES.CATEGORY_PRODUCT),
    addProduct: generateCreateActionCreator(routes.API_PRODUCT, ACTION_NAMES.PRODUCT),
    isDuplicate: generateReadActionCreator(`${routes.API_PRODUCT}/check_duplicate`, ACTION_NAMES.CHECK_PRODUCT_DUPLICATE),
    getOpenSubscriptionSlots: generateReadActionCreator(`${routes.API_PRODUCT}/open_subscription_slots`, ACTION_NAMES.OPEN_SUBSCRIPTION_SLOTS),
    assignNumber: generateUpdateActionCreator(`${routes.API_PRODUCT}/assign-number-to-slot`, ACTION_NAMES.ASSIGN_NUMBER),
    getProductLimits: generateReadActionCreator(routes.API_PRODUCT_CATALOG_PRODUCT_LIMITS, ACTION_NAMES.PRODUCT_CATALOG_PRODUCT_LIMITS)
}
